import { useProperty } from '@spotify-internal/remote-config-integration-react';

import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';
import { useSemanticSearch } from 'utils/remote-config/properties';
import { Vertical } from 'utils/vertical';

const useShouldUseSemanticSearch = () => {
  const shouldUseSemanticSearch = useProperty(useSemanticSearch, { loadingValue: false });
  const {
    market: { locale },
    verticalConfig,
  } = useServerSideConstants();

  return verticalConfig.verticalName === Vertical.CONSUMER && locale === 'en-US' && shouldUseSemanticSearch;
};

export default useShouldUseSemanticSearch;
